import storageUtil from "../../../utils/StorageUtil";
import { environment } from "../../../environments/environment";
import {Constants} from "@/components/Constants";

/** Authorization header. */
const authorizationHeader = "Authorization";

/** Two factor access token header. */
const twoFactorAccessTokenHeader = "Fineract-Platform-TFA-Token";

const httpOptions = {
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "Fineract-Platform-TenantId": environment.fineractPlatformTenantId
  }
};

export default {

  /**
   * Gets the http headers.
   */
  getHeaders() {
    return httpOptions;
  },

  /**
   * Gets the http headers.
   */
  getAuthorizationHeader() {
    return storageUtil.getItem(authorizationHeader)
    // return httpOptions.headers[authorizationHeader];
  },

  /**
   * Sets the basic/oauth authorization header depending on the configuration.
   * @param {string} authenticationKey Authentication key.
   */
  setAuthorizationToken(authenticationKey) {
    if (environment.authenticationType === Constants.AUTH_TYPE_OAUTH) {
      storageUtil.setItem(authorizationHeader, `Bearer ${authenticationKey}`);
      // httpOptions.headers[authorizationHeader] = `Bearer ${authenticationKey}`;
    } else {
      storageUtil.setItem(authorizationHeader, `Basic ${authenticationKey}`);
      // httpOptions.headers[authorizationHeader] = `Basic ${authenticationKey}`;
    }
  },

  /**
   * Sets the two factor access token header.
   * @param {string} twoFactorAccessToken Two factor access token.
   */
  setTwoFactorAccessToken(twoFactorAccessToken) {
    storageUtil.setItem(twoFactorAccessTokenHeader, twoFactorAccessToken);
    // httpOptions.headers[twoFactorAccessTokenHeader] = twoFactorAccessToken;
  },

  /**
   * Removes the authorization header.
   */
  removeAuthorization() {
    storageUtil.removeItem(authorizationHeader);
    // delete httpOptions.headers[authorizationHeader];
  },

  /**
   * Removes the two factor access token header.
   */
  removeTwoFactorAuthorization() {
    storageUtil.removeItem(twoFactorAccessTokenHeader);
    // delete httpOptions.headers[twoFactorAccessTokenHeader];
  },

  /**
   * Removes allAuth headers.
   */
  removeAllAuthorization() {
    this.removeAuthorization();
    this.removeTwoFactorAuthorization();
  }
};
